import React from "react"
import { Div, Text } from "atomize"
import { theme } from "../settings/config"
import RadioBox from "../atoms/RadioBox"
import { PAID_TO_COACH, PAID_TO_SCHOOL } from "../utils/billing.utils"

// A chi pagano di solito gli allievi delle private in questo circolo. Di
// norma a te; dove si paga in segreteria pagano il circolo, che si tiene la
// quota di campo e il resto te lo deve: il riepilogo deve saperlo, altrimenti
// conta come incasso tuo dei soldi che sono ancora al circolo.
//
// È la regola di partenza, non una condanna: ogni allievo di ogni lezione
// può fare diversamente, e si cambia dal modulo della lezione.
const OPTIONS = [
	{
		value: PAID_TO_COACH,
		title: "A me",
		detail: "Incassi tu, e scegli lezione per lezione come ti hanno pagato.",
	},
	{
		value: PAID_TO_SCHOOL,
		title: "Al circolo",
		detail:
			"Il circolo si tiene la quota di campo e il resto lo fatturi a lui: il riepilogo lo tiene da parte.",
	},
]

function PlayersPayToEditor({ playersPayTo, onChange }) {
	return (
		<Div m={{ b: "1.5rem" }}>
			<Text
				textSize="body"
				textWeight="bold"
				textColor={theme.colors.text_light}
				m={{ b: "0.5rem" }}>
				Di solito gli allievi pagano
			</Text>

			{OPTIONS.map(option => (
				<Div key={option.value} m={{ b: "0.5rem" }}>
					<RadioBox
						text={option.title}
						checked={playersPayTo === option.value}
						handleChange={() => onChange(option.value)}
					/>
					<Text
						textSize="caption"
						textColor={theme.colors.text_light}
						m={{ l: "2.5rem" }}>
						{option.detail}
					</Text>
				</Div>
			))}

			<Text textSize="caption" textColor={theme.colors.text_light} m={{ t: "0.75rem" }}>
				I metodi qui sotto sono quelli con cui ti pagano quando pagano te.
			</Text>
		</Div>
	)
}

export default PlayersPayToEditor
